import { useEffect } from 'react'
import { treeify } from '../../../common/Helpers';
import { getUsersMemberByElementId } from '../../../services/sKPI/element.service';


const useGetUsersMemberByElementId = (elementId, usersArray, setUsersArray, selectInitialData, initialIdsDataArray, isPanelOpen, forceUpdate, isTreeify) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getUsersMemberByElementId(elementId);

                if (serviceResponse.data.succeeded) {
                    if (isTreeify) {
                        serviceResponse = treeify(serviceResponse !== null ? serviceResponse.data.data : [], 'id', null, 'children', null, 'username');
    
                        if (selectInitialData) {
                            serviceResponse.forEach(element => {
                                initialIdsDataArray.forEach(id => {
                                    if (element.username === id) {
                                        element.checked = true;
                                    }
                                });
                            });
                        }

                        setUsersArray && setUsersArray(serviceResponse)
                    }
                    else {
                        setUsersArray && setUsersArray(prevState => ({
                            ...prevState,
                            fireUpdate: true,
                            data: serviceResponse.data.data
                        }));
                    }
                }
                else {
                    setUsersArray && setUsersArray(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));
                }
            }
            catch (error) {
                if (isTreeify) {
                    setUsersArray && setUsersArray([])
                }
                else {
                    setUsersArray && setUsersArray(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));
                }
            }
        }
        
        if ((elementId !== null && ((usersArray === null || usersArray.length === 0) || forceUpdate) && isPanelOpen) && (selectInitialData === true ?  ((initialIdsDataArray !== null)? initialIdsDataArray.length > 0 : true) : true)) {
            getData()
        }
    }, [elementId, usersArray, setUsersArray, selectInitialData, initialIdsDataArray, isPanelOpen, forceUpdate, isTreeify]);
}


export {
    useGetUsersMemberByElementId,
}